import { useState } from "react";

import axios from "axios";

// import Swal from "sweetalert2";
import { errorModal, questionModal, successModal } from "../../../Components/CustomModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useSearchParams } from 'react-router-dom';


import CustomButton from "../../../Components/CustomButton";

import "../style.css";
import BASEURL from "../../../Config/global";
import { useEffect } from "react";
import SubCategoryComponent from "../SubCategoryComponent";
import { Modal, Spinner } from "react-bootstrap";
import CustomInput from "../../../Components/CustomInput";
import CustomFilters from "../../../Components/CustomFilters";
import { AddImageComponent } from "../../CategoryManagement/ImageComponent";
import CustomPagination from "../../../Components/CustomPagination";
import { deleteRequest, patchRequest, postRequest } from "../../../Util/requests";
import SubCategoryAddEdit from "./SubCategoryAddEdit";

const SubcategorGeneral = ({ categoryUrl, subCategoryUrl }) => {
    const [inputValue, setinputValue] = useState();
    const [editId, setEditId] = useState();
    const [subCategories, setSubCategories] = useState([])
    const [showSwapModal, setShowSwapModal] = useState(false);
    const [swapInputError, setInputError] = useState({ error: true, text: '' });
    const [selectedTrack, setSelectedTrack] = useState();
    const [soundCategoryData, setSoundCategoryData] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const [soundImage, setSoundImage] = useState(null);
    const [child_content, setChildContent] = useState(null);
    const [defaultCategory, setDefaultCategory] = useState(false);
    const [restrictPrimaryUser, setRestrictPrimaryUser] = useState(false);

    const [filterSearchValue, setFilterSearchValue] = useState("");
    const [enteries, setEnteries] = useState(10);
    const [offset, setOffset] = useState(0);
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [totalCount, setTotalCount] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [selectedLanguage, setSelectedLanguage] = useState('english');
    const [modalLanguage, setModalLanguage] = useState('english');



    // useEffect(() => {
    //     if (currentPage != undefined) {
    //         setOffset(currentPage);
    //     }
    // }, [currentPage])

    useEffect(() => {
        // Clear data when language changes
        setSoundCategoryData([]);
        setSubCategories([]);
        setTotalCount(0);
        setSelectedTrack(undefined);
        fetchSound()
    }, [selectedLanguage])
    useEffect(() => {
        if (!selectedTrack) {
            setSubCategories([]);
            setTotalCount(0);
            return;
        }
        getExistingSoundSubCategories(selectedTrack)
    }, [selectedTrack, enteries, offset,  filterSearchValue]);

    // useEffect(() => {
    //     if (Number(totalCount) < enteries) {
    //         setEnteries(totalCount)
    //     } else {
    //         setEnteries(10)
    //     }
    // }, [totalCount])

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        // setSelectedImage(file);
        if (file === null || file === "undefined" || file === undefined) {
            //   setSoundImage(null);
        } else {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                setSoundImage(reader.result);
                setSelectedImage(reader.result);

                console.log(reader)
            };
        }
    };
    const handleRemoveImage = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setSoundImage(null)
        setSelectedImage(null)
    }

    const fetchSound = async () => {
        try {
            setLoading(true)
            const languageParam = selectedLanguage === 'spanish' ? '?language=spanish' : '';
            const response = await axios.get(`${BASEURL}${categoryUrl}${languageParam}`);
            setLoading(false)
            if (response.data.data) {
                const sortedData = response.data.data.sort(function (a, b) { return a.sequence - b.sequence })
                setSoundCategoryData(sortedData);
            }
        } catch (error) {
            console.error(error);
            setLoading(false)
        }
    }
    const getExistingSoundSubCategories = async (trackId) => {
        if (!trackId || trackId === "" || trackId === "undefined") {
            setSubCategories([]);
            setTotalCount(0);
            return
        }
        const requestOptions = {
            method: "GET",
            redirect: "follow"
        };
        const languageParam = selectedLanguage === 'spanish' ? '&language=spanish' : '';
        fetch(`${BASEURL}${subCategoryUrl}/${trackId}?limit=${enteries}&offset=${offset}&start_date=${dateFrom}&end_date=${dateTo}&search=${filterSearchValue}${languageParam}`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result.status === 200) {
                    setSubCategories(result?.data)
                    setTotalCount(result?.count)
                    if (result?.data?.length) {

                    }
                }
            })
            .catch((error) => console.error(error));
    }
    const postData = async (updatedCategories, method) => {
        try {
            if (!selectedTrack && updatedCategories && method) {
                return
            }
            const apiUrl = `${categoryUrl}`;
            const raw = JSON.stringify({
                "id": selectedTrack,
                "category_data": updatedCategories,
                "language": modalLanguage
            });
            // const url = `/api/sounds/soundscategories`
            if (method === "POST") {
                return await postRequest(apiUrl, raw,)
            } else {
                return await patchRequest(apiUrl, raw,)
            }
        } catch (error) {
            console.error(error);
        }
    };



    const addCategory = async (event) => {
        if (inputValue !== "") {
            questionModal
                .fire({
                    title: `Do you want to ${editId ? "update" : "add"} this sub category?`,
                    confirmButtonText: editId ? "Update" : "Add",
                })
                .then(async (result) => {
                    if (result.isConfirmed) {
                        const response = await postData([{
                            id: editId ? editId : subCategories.length + 1,
                            name: inputValue,
                            banner: selectedImage,
                            child_content: child_content,
                            // is_default: defaultCategory,
                            restrict_primary_user: restrictPrimaryUser,
                            language: modalLanguage
                        }], editId ? "PUT" : "POST");
                        if (response.data.error === false) {
                            setinputValue("")
                            setEditId("")
                            setShowSwapModal(false)
                            await getExistingSoundSubCategories(selectedTrack)
                            successModal.fire({
                                text: `Sub category ${editId ? "Updated" : "Added"}  Successfully`,
                                confirmButtonText: "Continue",
                            });
                            setChildContent(false)
                            setDefaultCategory(false)
                            setSelectedImage(null)
                            setSoundImage(null)
                            setRestrictPrimaryUser(false)
                        }
                    }
                });
        }
        else {
            setInputError({ error: true, 'text': 'Sub category title cannot be empty' })
        }
    }

    const handleEditItemCallBack = (data) => {
        console.log("data", data)
        setinputValue(data.name)
        setSelectedImage(data.banner)
        setSoundImage(data.banner)
        setEditId(data.id)
        setChildContent(data.child_content)
        // setDefaultCategory(data.is_default)
        setRestrictPrimaryUser(data.restrict_primary_user)
        setModalLanguage(data.language || selectedLanguage)
        setShowSwapModal(true)
    }

    const handleDeleteItemCallBack = async (item) => {
        questionModal
            .fire({
                title: "Do you want to delete this sub category",
                confirmButtonText: "Delete",
            })
            .then(async (result) => {
                if (result.isConfirmed) {
                    const response = await deleteRequest(`${categoryUrl}/${item}`)
                    if (response.data.error === false) {
                        successModal.fire({
                            text: "Sub category deleted Successfully.",
                            confirmButtonText: "Continue",
                        });
                        setSubCategories([...subCategories.filter(subcategory => subcategory.id !== item)]);
                    } else {
                        errorModal.fire({
                            text: "Unable to delete Sub category.",
                            confirmButtonText: "Continue",
                        });
                    }
                }
            });
    }

    const setSelectedTrackHandler = (event) => {
        const value = event.target.value;
        setSelectedTrack(value === "" || value === "undefined" ? undefined : value)
    }
    const handleChangeEntries = (no) => {
        setOffset(0)
        setEnteries(no)
    }

    if (loading) {
        return (
            <div className="row">
                <div className="center-align">
                    <div className="spinner-border" role="status"></div>
                </div>
            </div>
        )
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-6 mb-2 ">
                    <div className="d-flex flex-row align-items-center">
                        <p className="mainLabel mt-2">Select Category*</p>
                        {soundCategoryData && (
                            <select
                                name="category"
                                id="category"
                                className="mainInput w-auto"
                                required
                                value={selectedTrack || ""}
                                onChange={setSelectedTrackHandler}
                            >
                                <option value="">{"Select Category"}</option>
                                {soundCategoryData.map((item, index) => (
                                    <option key={index} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                        )}
                    </div>
                </div>
                <div className="col-3 ms-auto text-end">
                    <button
                        disabled={!selectedTrack ? true : false}
                        onClick={() => {
                            setEditId("")
                            setinputValue("")
                            setModalLanguage(selectedLanguage)
                            setShowSwapModal(true)
                            setInputError({ error: false, text: '' })
                            setSelectedImage(null)
                            setSoundImage(null)
                            setRestrictPrimaryUser(false)
                        }}
                        className={`customButton ${!selectedTrack ? '' : 'primaryButton'}`}
                    >
                        Add
                    </button>
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-12 ">
                    <div className="row mb-3">
                        <div className="col-12">
                            <CustomFilters
                                enteries={enteries}
                                totalCount={totalCount}
                                entriesFilter={true}
                                setEnteries={handleChangeEntries}
                                filterSearch={true}
                                filterSearchValue={filterSearchValue}
                                setFilterSearchValue={setFilterSearchValue}
                                // languageFilter={true}
                                // languageValue={selectedLanguage}
                                // setLanguageValue={setSelectedLanguage}
                            // dateFilter={true}

                            />
                        </div>
                    </div>
                </div>


            </div>
            <div className="row mb-3">
                <div className="col-12">
                    {
                        <SubCategoryComponent
                            data={subCategories}
                            handleDeleteItemCallBack={handleDeleteItemCallBack}
                            handleEditItemCallBack={handleEditItemCallBack}

                        />
                    }
                </div>
                <div className="row mb-3">
                    <div className="col-12">
                        {" "}
                        <CustomPagination
                            enteries={enteries}
                            totalCount={totalCount}
                            setCurrentPage={setOffset}
                            currentPage={offset}

                        />
                    </div>
                </div>
                {/* <SubCategoryAddEdit
                    showSwapModal={showSwapModal}
                    setEditId={setEditId}
                    setinputValue={setinputValue}
                    setShowSwapModal={setShowSwapModal}
                    setInputError={setInputError}
                    soundImage={soundImage}
                    editId={editId}
                    swapInputError={swapInputError}
                    addCategory={addCategory}
                    inputValue={inputValue}
                    handleImageChange={handleImageChange}
                    handleRemoveImage={handleRemoveImage}
                /> */}
                <Modal
                    show={showSwapModal}
                    centered
                    className="swap-modal"
                    backdrop="static"
                >
                    <Modal.Body>
                        <div className="pb-5 w-100 d-flex flex-column align-items-center">
                            <div className="d-flex justify-content-between w-100 px-3">
                                <h2 className="mainTitle">{editId ? "Edit" : "Add"} Sub Category</h2>
                                <div className="text-end ms-auto">
                                    <button
                                        className="closeButton notButton ms-auto"
                                        onClick={() => {
                                            setEditId("")
                                            setinputValue("")
                                            setShowSwapModal(false)
                                            setInputError({ error: false, text: '' })
                                            setModalLanguage(selectedLanguage)
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faTimes}
                                            className="cross-icon"
                                            color="white"
                                        />
                                    </button>
                                </div>
                            </div>
                            <div className="d-flex flex-column align-items-start w-100 mt-3">
                                <div className="w-100 px-3 mx-1" style={{}}>
                                    <CustomInput
                                        label="Title"
                                        labelClass="mainLabel"
                                        required
                                        type="text"
                                        name="title"
                                        value={inputValue}
                                        placeholder="Enter Sub Category"
                                        inputClass="mainInput"
                                        onChange={(ev) => {
                                            setinputValue(ev.target.value)
                                            setInputError({ error: false, text: '' })
                                        }}
                                    />
                                </div>

                                <AddImageComponent
                                    soundImage={soundImage}
                                    handleImageChange={handleImageChange}
                                    handleRemoveImage={handleRemoveImage}
                                    inputClass="w-100 px-3 modal-image"
                                />
                                <div className="mt-2 px-3 mx-1">
                                        <input
                                            type="checkbox"
                                            name="featured"
                                            id="featured"
                                            onChange={() => {
                                                setChildContent(!child_content);
                                            }}
                                            value={child_content}
                                            checked={child_content ? true : false}
                                        />
                                        <label htmlFor="featured" className="mainLabel ms-1">
                                            Underage Restriction
                                        </label>
                                    </div>
                                {/* <div className="mt-2 px-3 mx-1">
                                    <input
                                        type="checkbox"
                                        name="featured"
                                        id="featured"
                                        onChange={() => {
                                            setDefaultCategory(!defaultCategory);
                                        }}
                                        value={defaultCategory}
                                        checked={defaultCategory ? true : false}
                                    />
                                    <label htmlFor="featured" className="mainLabel ms-1">
                                        By Default
                                    </label>
                                </div> */}
                                <div className="mt-2 px-3 mx-1">
                                    <input
                                        type="checkbox"
                                        name="restrict_primary_user"
                                        id="restrict_primary_user"
                                        onChange={() => {
                                            setRestrictPrimaryUser(!restrictPrimaryUser);
                                        }}
                                        value={restrictPrimaryUser}
                                        checked={restrictPrimaryUser ? true : false}
                                    />
                                    <label htmlFor="restrict_primary_user" className="mainLabel ms-1">
                                        Restrict Primary User
                                    </label>
                                </div>
                                 {/* <div className="w-50 px-3 mx-1 mb-3 mt-2" style={{ display: 'none' }}>
                                     <label className="mainLabel">Select Language*</label>
                                     <select
                                         name="language"
                                         id="language"
                                         className="mainInput"
                                         value={modalLanguage}
                                         onChange={(e) => setModalLanguage(e.target.value)}
                                         style={{ width: '100%' }}
                                     >
                                         <option value="english">English</option>
                                         <option value="spanish">Spanish</option>
                                     </select>
                                 </div> */}
                            </div>

                            {swapInputError?.error && <small className="text-danger mt-3">{swapInputError.text}</small>}
                            <div className=" pt-3 d-flex gap-3 justify-content-center">
                                <button style={{ backgroundColor: '#ffffff1f' }} className='px-5 py-2 fs-6 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0' onClick={addCategory}>
                                    <span className=''>{editId ? "UPDATE" : "Add"}</span>
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>

        </div>
    );
};
export default SubcategorGeneral;